export default __webpack_public_path__ + "static/media/HelpEmail.55c4fd07.svg";